import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@environments/environment";
import { Observable, throwError } from "rxjs";
import { Statistics } from "@features/snowflake/state";
import { catchError } from "rxjs/operators";

export interface UDFSnowflakeUser {
    oid: string;
    upn: string;
}
@Injectable({
    providedIn: "root",
})
export class UDFApiService {
    udfApiUrl: string;

    constructor(private http: HttpClient) {
        this.udfApiUrl = environment.udfApiUrl;
    }
    
    getGraphMemberOf(memberId: string): Observable<any> {
        return this.http.get(
            `${this.udfApiUrl}/api/GraphApiSearch/MemberOf?memberId=${memberId}`,
        );
    }

    getGraphUser(user: string): Observable<any> {
        return this.http.get(
            `${this.udfApiUrl}/api/GraphApiSearch/Users?search=${user}`,
        );
    }

    getTags(): Observable<any> {
        return this.http.get(`${this.udfApiUrl}/api/Tag`);
    }

    postIngestionRequest(data: any): Observable<any> {
        return this.http.post(`${this.udfApiUrl}/api/IngestionRequest`, data);
    }

    getStatistics(): Observable<Statistics> {
        const url = `${this.udfApiUrl}/api/Snowflake/getTop5Metrics`;
        return this.http
            .get<Statistics>(url)
            .pipe(catchError(this.handleHttpError));
    }

    handleHttpError(error) {
        return throwError(error.message || "Server Error");
    }
}
